<template>
  <div class="d-flex flex-wrap">
    <div class="d-flex w-100 mb-2">
      <select ref="tagSelectRef" class="form-control tag-lookup mr-2" multiple
              style="width: 100%;"></select>
    </div>
    <div class="d-flex w-100">
      <div style="width: 90%; margin-right: 0.5rem;">
        <select ref="selectRef" class="form-control chapter-lookup mr-2" style="width: 100%; "></select>
      </div>
      <button aria-label="add chapter" class="btn btn-default btn-sm" style="width: 10%;" type="button"
              v-on:click="addChapter()"><i class="fa fa-plus"></i>
      </button>
    </div>
  </div>
</template>

<script setup>
import {ref, onMounted} from 'vue'

const props = defineProps({
  uuid: String,
  chapters: Array
})

const selected = ref(null)
const tagFilter = ref([])
const emit = defineEmits(['addChapter'])

const addChapter = () => {
  if (!selected.value) {
    return
  }
  emit('addChapter', selected.value)
  selected.value = null
  $(selectRef.value).val(null).trigger('change')
};

const removeChapter = (chapters, index) => {
  chapters.splice(index, 1)
};

const exclude = () => {
  return props.chapters.map((item) => item.chapId)
};

// Refs to DOM elements
const selectRef = ref(null)
const tagSelectRef = ref(null)


onMounted(() => {

  $(tagSelectRef.value).select2({
    placeholder: 'Filter by tags',
    multiple: true,
    ajax: {
      url: '/api/tags',
      dataType: 'json',
      data: function (params) {
        return {
          search: params.term
        }
      },
      processResults: function (data) {
        return {
          results: data.data.map((item) => {
            return {id: item.id, text: item.name}
          })
        };
      }
    }
  }).on('change', function () {
    const selectedTags = $(this).select2('data')
    tagFilter.value = selectedTags.map((item) => item.text)
  });

  $(selectRef.value).select2({
    placeholder: 'Select a scenario',
    ajax: {
      url: '/api/chapters',
      dataType: 'json',
      data: function (params) {
        return {
          search: params.term,
          tags: tagFilter.value,
          exclude: exclude()
        }
      },
      processResults: function (data) {
        return {
          results: data.data.map((item) => {
            return {id: item.id, text: `${item.name} - (${item.id})`}
          })
        };
      }
    }
  }).on('change', function () {
    const selectedData = $(this).select2('data')
    selected.value = selectedData[0]
  });
});
</script>
